import React, { useEffect, useState } from "react";
import Work from "./Work";
import Typist from "react-typist";
import Carousel from "../Shared/Carousel";
import workpic from "../../assets/images/MotoPeddler.png";
import charitypic from "../../assets/images/charity.png";
import pospic from "../../assets/images/pos.png";
import ibpic from "../../assets/images/ib.png";
const Works = () => {
  const [showTyper, setShowTyper] = useState(true);
  const works = [
    {
      id: 1,
      category: "Full Stack Development",
      title: "Charity",
      pic: charitypic,
      desciption:
      "It is a complete web application implemented for a charity organization. The organization can post campaigns, appeals or events from admin dashboard. Can also calculate zakat based on nisab. Admin can change the contents of landing page. It is a charity organization management system which has HRM module, Accounting and Finance Module, Payment Gateway Setup and last but not the least a Content Management System.",
      technologies: "Laravel, Vue.js, MySQL",
      admin: true,
      website: true,
      client: false,
      gitlink: "https://github.com/Jawad0501/charity",
      sitelink: "https://charity.lilliput.digital/",
      adminlink: "https://charity.lilliput.digital/admin/login"
    },
    {
      id: 2,
      category: "Functional Admin Dashboard",
      title: "POSINV - POS & Inventory Management",
      pic: pospic,
      desciption:
        "Has Multiple Roles and Permission Middleware Implemented. A Point of Sale functionality. All sales history. Stock Management and Adjustment. Report generation and many more.",
      technologies: "Laravel, Blade, MySQL",
      admin: true,
      website: false,
      client: false,
      gitlink:"https://github.com/Jawad0501/posinv",
      adminlink:"https://shamsaltaqwa.lilliput.digital/staff/login"
    },
    {
      id: 3,
      category: "Functional Client And Admin Dashboard",
      title: "Immersive Brands",
      pic: ibpic,
      desciption:
        "Saving Products, Sending Quotation to Customers, Quotation to Order Confirmation and Delivery with live email update. Internal File Manager System.",
      technologies: "Laravel, Blade, MySQL",
      admin: true,
      website: false,
      client: true,
      gitlink:"https://github.com/Jawad0501/ib",
      adminlink:"https://jawad.lilliput.digital/admin/login",
      clientlink:"https://jawad.lilliput.digital/login"
    },
    // {
    //   id: 4,
    //   category: "WEB DEVELOPMENT",
    //   title: "Full Stack Website",
    //   pic: workpic,
    //   desciption:
    //     "Loremfasd lkdasjflak jfldask jldkfl aksjflka jlfd lkfjla sdkfdl klaf lfl kalfk sdlfs dajlf jllk asldkf jlkfk",
    //   technologies: "Laravel, Vue.js, MySQL",
    //   admin: false,
    //   website: false
    // },
  ];

  return (
    <div className="w-full px-5 md:px-20 " data-aos="fade-up">
      <div className="flex items-center justify-center my-3  space-x-4">
        {/* <h6 className=" text-lg text-white">MY</h6> */}
        <h6 className="text-green-500 font-bold font-roboto text-3xl ">
          &lt; MY WORKS / &gt;
        </h6>
      </div>
      <div className="flex w-full justify-center items-center">
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        <span className="mx-2"></span>
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        <span className="mx-2"></span>
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        <span className="mx-2"></span>
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
        <span className="mx-2"></span>
        <div className=" my-1 bg-white w-full" style={{ height: "2px" }} />
      </div>
      {/* Individual projects below */}
      {showTyper ? (
        <div className="w-full text-center my-40">
          <Typist onTypingDone={() => setShowTyper(!showTyper)}>
            <h3 className="text-3xl font-bold text-[#F0E68C]">Loading...</h3>
          </Typist>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-[50px] my-10">
          {works.map((work, index) => (
            <Work
              index={index + 1}
              id={work.id}
              key={work.id}
              workpic={work.pic}
              title={work.title}
              category={work.category}
              desciption={work.desciption}
              technologies={work.technologies}
              admin={work.admin}
              website={work.website}
              client={work.client}
              gitlink = {work.gitlink}
              sitelink = {work.sitelink}
              adminlink = {work.adminlink}
              clientlink={work.clientlink}
            ></Work>
          ))}
        </div>
      )}
    </div>
  );
};

export default Works;
